import styled from 'styled-components';
import { Page } from 'components/molecules/page';

export const PageContent = styled(Page.Content)`
  padding: var(--layout-01) var(--layout-02);

  > .ant-row {
    padding: var(--spacing-03);
  }
`;
